import { addIcons } from "ionicons";
import { environment } from "src/environments/environment";

const iconMap = [
    'chevron-back-outline',
    'chevron-forward-outline',
    'refresh-outline',
    'close-circle-outline',
    'add',
    'add-outline',
    'help-circle',
    'chevron-up-circle-outline',
    'chevron-down-circle-outline',
    'close',
    'file-pdf-solid',
    'caret-forward-outline',
    'caret-down-outline'
];

export function mapIcons() {
    const map: { [name: string]: string } = {};

    for (const key of iconMap) {
        map[key] = `${environment.imageBase}/svg/${key}.svg`;
    }

    addIcons(map);
}